<template>
  <div v-for="(file, index) in files" :key="index" class="col">
    <div class="position-relative">
      <div v-if="file.id" class="ratio ratio-16x9 bg-white border">
        <img
          @click="showLightBox(index)"
          :src="displayImage(file)"
          :class="thumbnail_class"
        />
      </div>
      <div v-else>
        <slot name="image-placeholder">
          <div
            class="ratio ratio-16x9 bg-white border d-flex align-items-center justify-content-center"
          >
            No Image
          </div></slot
        >
      </div>
      <div v-if="file.id" class="position-absolute top-0 start-0 w-100">
        <slot
          name="thumbnail-operation-icons"
          :file="file"
          :index="index"
        ></slot>
      </div>
    </div>
  </div>

  <vue-easy-lightbox
    ref="lightbox"
    :visible="visible"
    :index="index"
    :imgs="imgs"
    teleport="body"
    @hide="hideLightBox"
  ></vue-easy-lightbox>
</template>

<script>
import { isVideo } from '@/utils/fileTypeUtils.js'
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'AppImageGallery',
  components: {
    VueEasyLightbox,
  },

  props: {
    files: {
      type: [Array, null],
      required: true,
    },
    show_lightbox: {
      type: Boolean,
      require: false,
      default: true,
    },
    thumbnail_class: {
      type: String,
      require: false,
      default: 'object-fit-cover',
    },
  },
  emits: ['ready'],

  data() {
    return {
      visible: false,
      index: 0,
    }
  },
  computed: {
    imageIndexes() {
      // 画像ファイルのみのインデックスリスト
      return this.files
        .map((file, idx) =>
          !isVideo(file) && file?.file_path && file?.file_type ? idx : null,
        )
        .filter((idx) => idx !== null)
    },
    imgs() {
      // 画像ファイルのみの配列
      return this.imageIndexes.map((idx) => {
        const file = this.files[idx]
        return {
          title: file.caption,
          src: file.file_path,
        }
      })
    },
  },

  mounted() {
    this.$emit('ready')
  },

  methods: {
    isVideo,
    displayImage(file) {
      if (file?.file_path && file?.file_type) {
        return file.file_path
      }
      return require('@/assets/no_image.svg')
    },
    showLightBox(fileIndex) {
      if (this.show_lightbox) {
        // files の index から imgs の index を取得
        const imgsIndex = this.imageIndexes.indexOf(fileIndex)
        if (imgsIndex !== -1) {
          this.index = imgsIndex
          const file = this.files[fileIndex]
          if (file?.id) {
            this.visible = true
          }
        }
      }
    },
    hideLightBox() {
      this.visible = false
    },
    zoomIn() {
      const btn = document.querySelector('.toolbar-btn.toolbar-btn__zoomin')
      btn?.click()
    },
    zoomOut() {
      const btn = document.querySelector('.toolbar-btn.toolbar-btn__zoomout')
      btn?.click()
    },
    resetZoom() {
      const btn = document.querySelector('.toolbar-btn.toolbar-btn__reset')
      btn?.click()
    },
  },
}
</script>
